

function isPasswordValid(password: string) {
  
  function checkContainsAnyLowerCase(password) { 
      return /[a-z]/g.test(password);
  }
  
  function checkContainsAnyUppercaseLetter(password) { 
      return /[A-Z]/g.test(password);
  }
  
  function checkContainsAnyBlankSpace(password) { 
      return /[\s]/i.test(password);
  }
  
  function checkContainsAnyNumber(password) {
      return /[\d]/i.test(password);
  }
  
  function checkContainsPunctuationAccentuationCharacter(password) {
      return /(?=.*[}{~'ãáâêàẽéêĩíîìõóôòũúûù])/.test(password)
  }
  
  function checkAllowedSpecialCharacters(password) {
      return /(?=.*[ç!@#$%*()=+¨&*()<>:;.,?^`'\-_\|/])/.test(password)
  }
  
  function validationPassword(): {message: string, isValid: boolean} {    
      let checkPasswordLenght = (password.length >= 8 && password.length <= 32)
      if (!checkPasswordLenght) return {message: "Senha Inválida, a senha deve conter de 8 a 32 caracteres!" , isValid: false}
      if (!checkContainsAnyLowerCase(password)) return {message: "Senha Inválida, acrescente uma letra minúscula!", isValid: false}
      if (!checkContainsAnyUppercaseLetter(password)) return {message: "Senha Inválida, acrescente uma letra Maiúscula!", isValid: false}
      if (checkContainsAnyBlankSpace(password)) return {message: "Senha Inválida, não deixe espaço em branco!", isValid: false}
      if (!checkContainsAnyNumber(password)) return {message: "Senha Inválida, acrescente um número!", isValid: false}
      if (checkContainsPunctuationAccentuationCharacter(password)) return {message: "Senha Inválida, caractere não permetido!", isValid: false}
      if (!checkAllowedSpecialCharacters(password)) return {message: "Senha Inválida, insira um caractere especial!", isValid: false}
  
      return {message: "Senha Válida!!", isValid: true}
  }

  return {validationPassword}
}

export { isPasswordValid}